/** Normalize storefront locale (e.g. de_DE) and map to Contentstack API language; default `de`. */
export const resolveContentstackLanguageCode = (locale: string): string => {
  const normalized = locale.replace(/_/g, '-')
  const contentStackLangMap: Record<string, string> = {
    'de-DE': 'de',
    'de-AT': 'de-at',
    'cs-CZ': 'cs-cz',
  }
  if (contentStackLangMap[normalized]) {
    return contentStackLangMap[normalized]
  }
  const base = normalized.split('-')[0]?.toLowerCase()
  if (base === 'de') {
    return 'de'
  }
  if (base === 'cs') {
    return 'cs-cz'
  }
  return 'de'
}
